import { Flex } from '@lokalise/louis';

import styled from '@app/styled';
import { spacing } from '@app/theme';

export const Footer = styled(Flex)`
    padding: ${spacing(5, 0)};
`;
